import { Link } from 'react-router-dom';
import '../../styles/App.css';

function Footer() {

    return (
        <footer className="footer" >
            <div className="footer-container">

                {/* Kolumna 1: O projekcie */}
                <div className="footer-info">
                    <h2>TRADI<span className="logo-highlight">WORLD</span></h2>
                    <p>
                        Interaktywna platforma 3D do dokumentowania i mapowania wspomnień z całego świata.
                    </p>
                    <p className='footer-links'>
                        <a href="/polityka-prywatnosci-tradiworld.pdf" target='_blank' rel="noopener noreferrer">Polityka prywatności</a> i <a href="/regulamin-serwisu-tradiworld.pdf" target='_blank' rel="noopener noreferrer">Regulamin</a>
                    </p>
                </div>

                {/* Kolumna 2: Nawigacja */}
                <div className="footer-column">
                    <h3>Eksploruj</h3>
                    <ul className="footer-links">
                        {/*<li><a href="#eksploruj" target='_blank' >GitHub</a></li>*/}
                        <li><a href="https://www.linkedin.com/in/milena-sampolska-b849043a5" target='_blank' rel="noopener noreferrer">LinkedIn</a></li>
                        <li><a href='https://www.instagram.com/tradi.world' target='_blank' rel="noopener noreferrer">Instagram</a></li>
                        <li><a href='https://www.facebook.com/share/1ErUFfcHUU/?mibextid=wwXIfr' target='_blank' rel="noopener noreferrer">Facebook</a></li>
                    </ul>
                </div>

                {/* Kolumna 3: Kontakt / Społeczność */}
                <div className="footer-column">
                    <h3>Kontakt</h3>
                    <ul className="footer-links">
                        <li><b>E-mail:</b> tradiworld.support@gmail.com<br/></li>
                        <li><Link to="/formularz-zgloszeniowy">Link do formularza kontaktowego</Link></li>

                    </ul>
                </div>

            </div>

            {/* Dolny pasek praw autorskich */}
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} TRADIWORLD. Wszelkie prawa zastrzeżone.</p>
                <div className="footer-socials">
                    <Link to="/o-autorze"  style={{color: "#00b4cc"}}>O autorze i historii powstawania projektu</Link>
                </div>
            </div>

        </footer>
    )
}

export default Footer;